
export class RecaptchaResponse {
    public success: boolean = false;
    public timestamp: Date = new Date();
    public hostname: string = '';
    public errorCodes: any[] = [];
}
